module.exports = __webpack_public_path__ + "img/logo-administracao.4cdc326a.svg";